import MaterialTable from 'material-table';
import React from 'react';

const GuiTable = (props) => {
  return <MaterialTable {...props} />;
};

export default GuiTable;
